import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { Box, IconButton, Typography, styled, useTheme } from '@mui/material';

import List from 'components/list/list';
import Tooltip from 'components/tooltip';

import { ReactComponent as CopyIcon } from '../assets/copy.svg';
import LoadingSpinner from 'components/loading-spinner';
import { useSiteSettingsState } from 'views/site-settings/context/site-settings-context';

type Props = {};

const StyledList = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 8,
  gap: 16,
  borderRadius: 8,
  padding: 8,
  background: theme.palette.common.white,
}));

const PAGE_NAME_ID = 'siteSettings.editSiteSettings';

const SiteContactEmails: React.FC<Props> = ({}) => {
  const theme = useTheme();

  const {
    siteSettingsQuery: { data: settings, isLoading },
  } = useSiteSettingsState();

  if (isLoading) return <LoadingSpinner />; // bad solution?
  if (!settings) return <></>;

  const contactEmails = useMemo(() => settings.emails, [settings]);

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
        <Typography sx={{ mb: { xs: 0 } }} variant="h3" color={theme.palette.common.white}>
          <FormattedMessage id={`${PAGE_NAME_ID}.emails`} />
        </Typography>
      </Box>
      <List
        noResult={{
          show: !contactEmails.length,
          text: <FormattedMessage id={`siteSettings.listSites.list.noResults`} />,
        }}>
        {contactEmails.map((email, idx) => {
          return (
            <StyledList key={`${idx}_${email}`}>
              <Typography
                color={theme.palette.common.black}
                noWrap
                sx={{ textTransform: 'lowercase', textAlign: 'left', pl: 2, maxWidth: { xs: 270, md: 480 } }}
                variant="body2">
                {email}
              </Typography>
              <Tooltip title="Copy to clipboard">
                <IconButton onClick={() => navigator.clipboard.writeText(email)}>
                  <CopyIcon fontSize={32} color={theme.palette.darkBlue.contrastText} />
                </IconButton>
              </Tooltip>
            </StyledList>
          );
        })}
      </List>
    </>
  );
};

export default SiteContactEmails;
